import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

export default function ProfileList({ hideTitle = false }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    api.get('users/?public=true')
      .then(({ data }) => {
        setUsers(data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Failed to fetch public profiles:", err);
        setError("Could not load profiles");
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading profiles...</p>;
  if (error) return <p style={{color: 'red'}}>{error}</p>;

  return (
    <div className="profile-list-container">
      {!hideTitle && <h2>Public Profiles</h2>}
      <div className="profile-list">
        {users.length > 0 ? (
          users.map(u => (
            <Link
              key={u.id}
              to={`/users/${u.id}`}
              className="profile-card"
            >
              <div className="avatar">
                {(u.display_name || u.username).charAt(0).toUpperCase()}
              </div>
              <div className="name">{u.display_name || u.username}</div>
            </Link>
          ))
        ) : (
          <p>No public profiles found.</p>
        )}
      </div>
    </div>
  );
}